export const productCategories = [
  { id: 'universal', label: 'Universal Kits', icon: 'ri-sun-line' },
  { id: 'epoxy', label: 'Epoxy Kits', icon: 'ri-flask-line' },
  { id: 'polyester', label: 'Polyester Kits', icon: 'ri-drop-line' },
  { id: 'softboard', label: 'Softboard', icon: 'ri-water-flash-line' },
  { id: 'micro', label: 'Micro Kits', icon: 'ri-capsule-line' },
];

export const products = [
  {
    id: 'universal-sunpowered-kit',
    slug: 'universal-sunpowered-kit',
    category: 'universal',
    name: 'Universal SunPowered Repair Kit',
    tagline: 'Works on any board. Cures in sunlight.',
    price: 34.95,
    originalPrice: 44.95,
    badge: 'Best Seller',
    rating: 4.9,
    reviewCount: 1284,
    image: 'https://public.readdy.ai/ai/img_res/44a881c1a1e69a3a6a5931a983ccac24.jpg',
    description: 'The complete all-in-one repair solution for epoxy and polyester surfboards. Sun-powered resin cures in 1-3 minutes in direct sunlight. Includes resin, fiberglass cloth, mixing tips, and sandpaper.',
    features: ['Works on epoxy & poly boards', 'Cures in 1-3 min sunlight', 'Includes all tools', 'Travel-safe packaging', 'Long shelf life'],
    includes: ['2x SunPowered Resin (10ml each)', 'Fiberglass cloth (4 sheets)', 'Mixing tips', 'Sandpaper (80/220 grit)', 'Application squeegee', 'Full instructions'],
    useCases: ['Dings & cracks', 'Rail damage', 'Nose/tail chips', 'Travel repairs'],
    heroImage: 'https://readdy.ai/api/search-image?query=surfer%20holding%20surfboard%20repair%20kit%20on%20sunny%20beach%20golden%20hour%20light%20ocean%20background%20lifestyle%20photography%20warm%20tones%20professional%20quality&width=1200&height=700&seq=prodhero1&orientation=landscape',
  },
  {
    id: 'epoxy-repair-kit',
    slug: 'epoxy-repair-kit',
    category: 'epoxy',
    name: 'Epoxy Surfboard Repair Kit',
    tagline: 'Engineered specifically for epoxy boards.',
    price: 29.95,
    originalPrice: null,
    badge: 'Epoxy Formula',
    rating: 4.8,
    reviewCount: 876,
    image: 'https://readdy.ai/api/search-image?query=epoxy%20surfboard%20repair%20kit%20product%20photography%20orange%20and%20white%20packaging%20resin%20tubes%20accessories%20flat%20lay%20clean%20background%20professional%20product%20shot&width=600&height=600&seq=prod2&orientation=squarish',
    description: 'Purpose-formulated epoxy resin system designed exclusively for EPS foam and epoxy laminate boards. Prevents yellowing and delamination with advanced bio-resin technology.',
    features: ['Epoxy-specific formula', 'Prevents delamination', 'UV & sunlight cure', 'Bio-resin technology', 'Crystal clear finish'],
    includes: ['2x Epoxy SunResin (10ml each)', 'Epoxy fiberglass cloth', 'Mixing cups', 'Brush applicator', 'Wet/dry sandpaper'],
    useCases: ['EPS foam boards', 'Epoxy laminates', 'Modern shortboards', 'Longboard repairs'],
    heroImage: 'https://readdy.ai/api/search-image?query=epoxy%20surfboard%20being%20repaired%20on%20beach%20sunlight%20curing%20resin%20surfer%20kneeling%20down%20repair%20kit%20lifestyle%20photography%20warm%20beach%20tones&width=1200&height=700&seq=prodhero2&orientation=landscape',
  },
  {
    id: 'polyester-repair-kit',
    slug: 'polyester-repair-kit',
    category: 'polyester',
    name: 'Polyester Surfboard Repair Kit',
    tagline: 'Classic formula for traditional poly boards.',
    price: 27.95,
    originalPrice: null,
    badge: 'Poly Formula',
    rating: 4.7,
    reviewCount: 643,
    image: 'https://readdy.ai/api/search-image?query=polyester%20surfboard%20repair%20kit%20yellow%20teal%20packaging%20resin%20product%20photography%20flat%20lay%20white%20background%20clean%20minimal%20professional&width=600&height=600&seq=prod3&orientation=squarish',
    description: 'Traditional polyester resin system optimized for PU foam and polyester laminate surfboards. Fast-curing formula with excellent adhesion and clear finish.',
    features: ['Poly-specific formula', 'Fast sunlight cure', 'Excellent adhesion', 'Clear finish', 'Compatible with all poly boards'],
    includes: ['2x Poly SunResin (10ml each)', 'Polyester cloth', 'Mixing sticks', 'Sanding pads'],
    useCases: ['PU foam boards', 'Traditional longboards', 'Fish shapes', 'Classic boards'],
    heroImage: 'https://readdy.ai/api/search-image?query=traditional%20polyester%20surfboard%20repair%20beach%20scene%20bright%20sunlight%20surfer%20fixing%20ding%20repair%20tools%20laid%20out%20sand%20lifestyle%20photography&width=1200&height=700&seq=prodhero3&orientation=landscape',
  },
  {
    id: 'softboard-repair-kit',
    slug: 'softboard-repair-kit',
    category: 'softboard',
    name: 'Softboard & Foamie Repair Kit',
    tagline: 'Specialized for foam top boards.',
    price: 24.95,
    originalPrice: null,
    badge: 'Foam Boards',
    rating: 4.6,
    reviewCount: 312,
    image: 'https://readdy.ai/api/search-image?query=softboard%20foam%20surfboard%20repair%20kit%20green%20packaging%20product%20photography%20repair%20tools%20accessories%20white%20background%20clean%20minimal&width=600&height=600&seq=prod4&orientation=squarish',
    description: 'Flexible repair solution designed for soft-top, foam, and beginner surfboards. Specialized adhesive compound bonds perfectly to foam materials without cracking or peeling.',
    features: ['Foam-compatible formula', 'Flexible repair bond', 'UV cure system', 'Beginner friendly', 'Non-toxic formula'],
    includes: ['Foam repair compound', 'Applicator tool', 'Patch material', 'Instructions'],
    useCases: ['Soft-top boards', 'Foam boards', 'Beginner boards', 'School/rental boards'],
    heroImage: 'https://readdy.ai/api/search-image?query=soft%20top%20foam%20surfboard%20being%20repaired%20on%20beach%20beginner%20surfer%20kits%20laid%20out%20repair%20in%20progress%20beach%20lifestyle%20sunny%20warm%20light&width=1200&height=700&seq=prodhero4&orientation=landscape',
  },
  {
    id: 'micro-emergency-kit',
    slug: 'micro-emergency-kit',
    category: 'micro',
    name: 'Micro Emergency Repair Kit',
    tagline: 'Pocket-sized. Always ready.',
    price: 14.95,
    originalPrice: null,
    badge: 'Travel Essential',
    rating: 4.8,
    reviewCount: 2103,
    image: 'https://readdy.ai/api/search-image?query=micro%20mini%20surfboard%20repair%20kit%20tiny%20compact%20pocket%20sized%20product%20photography%20white%20teal%20orange%20packaging%20flat%20lay%20minimal%20background&width=600&height=600&seq=prod5&orientation=squarish',
    description: 'The world\'s most travel-friendly surfboard repair kit. Fits in your boardshorts pocket. Pre-measured resin capsules, TSA-approved, and works in any sunlight. Never miss a session due to a ding again.',
    features: ['Fits in any pocket', 'TSA carry-on approved', 'Pre-measured capsules', 'No tools needed', 'Works anywhere with sun'],
    includes: ['3x Pre-measured resin capsules', 'Micro fiberglass patches', 'Sandpaper strip'],
    useCases: ['Emergency beach repairs', 'Travel kits', 'Surf trip essentials', 'Airline damage fixes'],
    heroImage: 'https://readdy.ai/api/search-image?query=tiny%20micro%20repair%20kit%20in%20surfer%20palm%20of%20hand%20on%20beach%20compact%20pocket%20sized%20emergency%20surfboard%20repair%20sunlight%20ocean%20background%20lifestyle&width=1200&height=700&seq=prodhero5&orientation=landscape',
  },
  {
    id: 'bio-resin-refill',
    slug: 'bio-resin-refill',
    category: 'universal',
    name: 'Bio-Resin SunCure Refill',
    tagline: 'Eco-friendly. Endless shelf life.',
    price: 19.95,
    originalPrice: null,
    badge: 'Eco',
    rating: 4.7,
    reviewCount: 487,
    image: 'https://readdy.ai/api/search-image?query=bio%20resin%20eco%20friendly%20surfboard%20repair%20refill%20bottles%20tubes%20green%20organic%20packaging%20product%20photography%20white%20background%20clean%20minimal%20sustainable&width=600&height=600&seq=prod6&orientation=squarish',
    description: 'Our eco-conscious bio-resin formula using plant-derived ingredients. Same fast sun-cure performance with reduced environmental impact. Refill tubes for any PHIX Doctor kit.',
    features: ['Plant-derived formula', 'Endless shelf life', 'Same fast cure', 'Eco-certified packaging', 'Refill any kit'],
    includes: ['4x Bio-Resin tubes (10ml each)', 'Mixing tips'],
    useCases: ['Kit refills', 'Eco-conscious surfers', 'Bulk repairs', 'Workshop stock'],
    heroImage: 'https://readdy.ai/api/search-image?query=eco%20friendly%20bio%20resin%20surfboard%20repair%20product%20nature%20beach%20green%20organic%20sustainable%20surf%20lifestyle%20photography%20warm%20natural%20lighting&width=1200&height=700&seq=prodhero6&orientation=landscape',
  },
];

export const getFeaturedProducts = () => products.slice(0, 5);
export const getProductById = (id: string) => products.find(p => p.id === id || p.slug === id);
export const getProductsByCategory = (category: string) => products.filter(p => p.category === category);
